import React from 'react';
import './investors.css';
import gigahub from '../../images/investors/gigahub1.png';

const InvestInAutzuTop = ({ isMobile }) => {
  return (
    <div className="top-section">
      <div className="linear-background">
        <div className="innerbox-investors">
          <div className="innertext">
            Autzu is a Mobility-Tech company, aiming to develop the
            infrastructure needed to utilize, manage and control autonomous
            vehicles globally.
          </div>
          <button
            className="innerbutton"
            onClick={() => window.open('mailto:investors@autzu.com')}>
            Invest in Autzu
          </button>

        </div>
        <img
        src={gigahub}
        className={isMobile ? 'gigahub-s' : 'gigahub'}></img>
      </div>
      
    </div>
  );
};

export default InvestInAutzuTop;



// WEBPACK FOOTER //
// ./src/components/Investors/InvestInAutzuTop.js